import { Paper, TextField } from '@mui/material';
import { Autocomplete } from '@mui/material';
import React from "react";

const AutocompleteInput = ({
  label,
  type,
  value,
  submitStatus,
  required,
  id,
  disabled,
  onChangeParent,
  onChangeParentManual,
  listData,
  onBlur,
  isAllowValidate = false,
  handleValidation,
  customAutocompletePaperClass = "",
  isOpenOnFocus = false,
  setOpenOnFocus,
}) => {
  const [open, setOpen] = React.useState(false);
  const [defualtValue, setDefualtValue] = React.useState(value ? value : "");

  return (
    <Autocomplete
      freeSolo
      id="free-solo-2-demo"
      className="auto-select"
      classes={{ paper: customAutocompletePaperClass }}

      PaperComponent={({ children }) => (
        <Paper sx={{ maxHeight: customAutocompletePaperClass ? "200px !important" : "auto",  overflow: "hidden"}}>
          {children}
        </Paper>
      )}
      open={open}
      onClose={() => {
        setOpen(false);
        isOpenOnFocus && setOpenOnFocus(false);
      }}
      onChange={(event, newValue) => {
        event.preventDefault();
        onChangeParent(newValue);
      }}
      onInputChange={(event, newInputValue) => {
        onChangeParentManual(newInputValue);
        if (newInputValue && newInputValue.length > 2) {
          setOpen(true);
          isOpenOnFocus && setOpenOnFocus(true);
        } else {
          setOpen(false);
          isOpenOnFocus && setOpenOnFocus(false);
        }
        onChangeParent(newInputValue);
      }}
      disableClearable
      value={defualtValue}
      disabled={disabled}
      getOptionSelected={(option) => option.value === defualtValue}
      options={listData}
      getOptionLabel={(options) => {
        return options || (options !== undefined && options !== "")
          ? options.title !== undefined
            ? options.title ?? ""
            : options
          : "";
      }}
      renderInput={(params) => (
        <TextField
          id={id}
          {...params}
          label={label}
          margin="normal"
          onBlur={onBlur}
          inputProps={isAllowValidate ? handleValidation(params) : params.inputProps}
          variant="standard"
        />
      )}
    />
  );
};

export default AutocompleteInput;
